import api from './api';

export interface PagaMeLink {
  id: string;
  code: string;
  url: string;
  descricao: string;
  valor: number | null;
  moeda: string;
  tipo: 'UNICO' | 'MULTIPLO';
  totalPagamentos: number;
  totalRecebido: number;
  estado: 'ACTIVO' | 'PAGO' | 'EXPIRADO' | 'CANCELADO';
  expiraEm: string | null;
  categoria: string | null;
  criadoEm: string;
}

export interface PagaMePayment {
  id: string;
  pagador_nome: string | null;
  pagador_email: string | null;
  valor: number;
  mensagem: string | null;
  estado: string;
  pago_em: string | null;
  created_at: string;
}

export interface CreateLinkParams {
  descricao: string;
  valor?: number | null;
  valorMinimo?: number | null;
  valorMaximo?: number | null;
  tipo?: 'UNICO' | 'MULTIPLO';
  maxPagamentos?: number | null;
  expiraEm?: string | null;
  categoria?: string | null;
}

class PagaMeService {
  async getLinks(): Promise<PagaMeLink[]> {
    const response = await api.get<{ success: boolean; data?: PagaMeLink[] }>(
      '/client/pagame/my/links'
    );
    if (response.data.success) return response.data.data || [];
    return [];
  }

  async createLink(params: CreateLinkParams): Promise<PagaMeLink> {
    const response = await api.post<{ success: boolean; data?: PagaMeLink; error?: string }>(
      '/client/pagame/my/links',
      params
    );
    if (response.data.success && response.data.data) return response.data.data;
    throw new Error(response.data.error || 'Erro ao criar link');
  }

  async getPayments(linkId: string): Promise<PagaMePayment[]> {
    const response = await api.get<{ success: boolean; data?: PagaMePayment[] }>(
      `/client/pagame/my/links/${linkId}/payments`
    );
    if (response.data.success) return response.data.data || [];
    return [];
  }

  async cancelLink(linkId: string): Promise<void> {
    const response = await api.delete<{ success: boolean; error?: string }>(
      `/client/pagame/my/links/${linkId}`
    );
    if (!response.data.success) throw new Error(response.data.error || 'Erro ao cancelar');
  }

  // Rota pública (sem auth) — para a página de pagamento
  async getPublicLink(code: string): Promise<any> {
    const response = await api.get<{ success: boolean; data?: any; error?: string }>(
      `/pagame/${code}`
    );
    if (response.data.success) return response.data.data;
    throw new Error(response.data.error || 'Link não encontrado');
  }

  async payLink(code: string, params: {
    valor?: number;
    pagador_nome?: string;
    pagador_email?: string;
    pagador_telefone?: string;
    mensagem?: string;
  }): Promise<{ pagamentoId: string; paymentUrl: string }> {
    const response = await api.post<{ success: boolean; data?: any; error?: string }>(
      `/pagame/${code}/pay`,
      params
    );
    if (response.data.success && response.data.data) return response.data.data;
    throw new Error(response.data.error || 'Erro ao processar pagamento');
  }
}

export const pagameService = new PagaMeService();
export default new PagaMeService();
